import * as React from "react";
import Service from "../service/Service";
import EstablishmentList from "../establishment/EstablishmentList";
import {useEffect} from "react";
import {useDarkMode} from "../darkMode/hook/useDarkMode";
import {Breadcrumbs, Typography, Container, Button, Box, Stack, IconButton} from "@mui/material";
import {useState} from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";

const Products = ({setShowNav}) => {
    const {mode} = useDarkMode();
    const [showMoveUpButton, setShowMoveUpButton] = useState(false);
    const [showMoveDownButton, setShowMoveDownButton] = useState(true);
    const [anchor, setAnchor] = useState(0);

    const moveUp = () => {
        const tempPosition = anchor - 1;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: "smooth",
            });
            setAnchor(anchor - 1);
        }
        const nextPosition = tempPosition - 1;
        if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveUpButton(false);
            setShowMoveDownButton(true);
        } else {
            setShowMoveUpButton(true);
            setShowMoveDownButton(true);
        }
    };

    const moveDown = () => {
        const tempPosition = anchor + 1;
        const tempAnchor = 'anchor'+tempPosition;
        const anchorEl = document.getElementById(tempAnchor);
        if (anchorEl) {
            window.scrollTo({
                top: anchorEl.offsetTop - process.env.REACT_APP_HEADER_HEIGHT,
                behavior: "smooth",
            });
            setAnchor(anchor + 1);
        }
        const nextPosition = tempPosition + 1;
        if (document.getElementById('anchor'+nextPosition) == null) {
            setShowMoveDownButton(false);
            setShowMoveUpButton(true);
        } else {
            setShowMoveDownButton(true);
            setShowMoveUpButton(true);
        }

    };

    useEffect(() => {
        setShowNav(true);
    }, []);
    return (
        <div style={{display : 'flex'}}>
            <Container className={'container'} style={{backgroundColor: mode.settings.backgroundColor}}>
                <Service setShowNav={setShowNav}></Service>
                <EstablishmentList/>
            </Container>
            {
                showMoveUpButton ?
                    <Box sx={{position: 'fixed', right: 0, top: '25%'}}>
                        <IconButton
                            className={'btn-gradient'}
                            sx={{
                                color: '#FFFFFF',
                                borderRadius: 0,
                                borderTopLeftRadius: '10%',
                                borderBottomLeftRadius: '10%'
                            }}
                            onClick={moveUp}
                        >
                            <ArrowUpwardIcon role="img" aria-label={"Remonter au bloc précédent"}/>
                        </IconButton>
                    </Box> : <div></div>
            }
            {
                showMoveDownButton ?
                    <Box sx={{position: 'fixed', right: 0, top: '32%'}}>
                        <IconButton
                            className={'btn-gradient'}
                            sx={{
                                color: '#FFFFFF',
                                borderRadius: 0,
                                borderTopLeftRadius: '10%',
                                borderBottomLeftRadius: '10%'
                            }}
                            onClick={moveDown}
                        >
                            <ArrowDownwardIcon role="img" aria-label={"Descendre au prochain bloc"}/>
                        </IconButton>
                    </Box>: <div></div>
            }
        </div>

    )
}

export default Products;
